import React from 'react';
import {
  Box,
  Button,
  Flex,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Space,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { Trans, useTranslation } from 'react-i18next';
import { FormLabel } from '@Components/Common/FormComponent';
import iconCredits from '../../../assets/image/icon-credits.svg';
import {
  AdvancedFeatureInfo,
  AdvancedFeatureTypeEnum,
  Service,
} from '@Types/app';
import { AdvancedTooltipStringList } from './advancedTooltip';

const AdvancedTooltipModal = React.memo(
  (props: {
    isVisible: boolean;
    onClose: () => void;
    onConfirm: () => void;
    advanceData: AdvancedFeatureInfo;
    advanceFeatureType: AdvancedFeatureTypeEnum;
  }) => {
    const { isVisible, onClose, advanceData, onConfirm, advanceFeatureType } =
      props;
    const { t } = useTranslation();
    const [colorMode] = useColorMode();
    const [colorStyle] = useColorStyle({ colorMode });
    const AdvanceProtectionInfo = {
      advancedProtectionServiceList: [
        t('dashboard.serviceStatus.advancedTooltip.inline'),
        t('common.service.gmailInline'),
        t('dashboard.serviceStatus.advancedTooltip.va'),
      ],
      advancedTooltipShouldShowList: [Service.ExchangeInline],
      creditsPerDefaultNumber: 4.17,
    };

    return (
      <Modal
        ensureFocus={true}
        autoFocus={false}
        closeOnEsc={true}
        closeOnOutsideClick={false}
        isClosable={true}
        isOpen={isVisible}
        onClose={onClose}
        size="sm"
      >
        <ModalOverlay opacity={0.9} />
        <ModalContent backgroundColor={colorStyle.background.secondary}>
          <ModalHeader>
            {t('dashboard.serviceStatus.enableAdvancedProtection.title')}
          </ModalHeader>
          <ModalBody>
            <Flex>{t('dashboard.serviceStatus.advancedTooltip.preDesc')}</Flex>
            <AdvancedTooltipStringList
              list={AdvanceProtectionInfo.advancedProtectionServiceList}
            ></AdvancedTooltipStringList>
            {/*TODO: add trial user api*/}
            {/*{isTrialUser && (*/}
            {/*  <Box mt="16px">*/}
            {/*    <Trans*/}
            {/*      i18nKey="dashboard.serviceStatus.enableAdvancedProtection.freeTrial"*/}
            {/*      values={{*/}
            {/*        NUMBER: license?.CAS?.expirationDate*/}
            {/*          ? dayjs(license.CAS.expirationDate).diff(dayjs(), 'day')*/}
            {/*          : 0,*/}
            {/*      }}*/}
            {/*    >*/}
            {/*      placeholder*/}
            {/*      <Link>placeholder</Link>*/}
            {/*    </Trans>*/}
            {/*  </Box>*/}
            {/*)}*/}
            {/*{!isTrialUser && (*/}
            <>
              <Flex flexDirection="column">
                {advanceData.aadUserCount &&
                advanceData.aadUserCount !== 0 &&
                advanceFeatureType === AdvancedFeatureTypeEnum.provision ? (
                  <Flex alignItems="center" mt="12px">
                    <FormLabel
                      color={colorStyle.color.primary}
                      width="100%"
                      label={t(
                        'dashboard.serviceStatus.enableAdvancedProtection.accounts'
                      )}
                    ></FormLabel>
                    <Text ml="76px">{advanceData.aadUserCount}</Text>
                  </Flex>
                ) : null}
                <Flex alignItems="center" mt="12px">
                  <Flex flexDirection="row">
                    {<img src={iconCredits} />}
                    <FormLabel
                      ml="4px"
                      width="100%"
                      color={colorStyle.color.primary}
                      label={t(
                        'dashboard.serviceStatus.enableAdvancedProtection.creditsTitle'
                      )}
                    ></FormLabel>
                  </Flex>
                  <Text ml="96px">
                    {t(
                      'dashboard.serviceStatus.enableAdvancedProtection.creditsContent',
                      {
                        NUMBER: AdvanceProtectionInfo.creditsPerDefaultNumber,
                      }
                    )}
                  </Text>
                </Flex>
              </Flex>
              <Box mt="16px" color={colorStyle.color.secondary}>
                <Trans i18nKey="dashboard.serviceStatus.enableAdvancedProtection.foot">
                  placeholder
                  <Link
                    onClick={() =>
                      (window.parent as any).APP.$router.push(
                        `/app/bc/company/credit`
                      )
                    }
                  >
                    placeholder
                  </Link>
                  placeholder
                </Trans>
              </Box>
              {Number(advanceData.aadUserCount) *
                AdvanceProtectionInfo.creditsPerDefaultNumber >
                Number(advanceData.avaliableCreit) && (
                <Flex mt="16px">
                  {t('dashboard.serviceStatus.enableAdvancedProtection.note')}
                </Flex>
              )}
            </>
            {/* )}*/}
          </ModalBody>
          <ModalFooter>
            <Button variant="primary" minWidth="20x" onClick={onConfirm}>
              {t('dashboard.serviceStatus.enableAdvancedProtection.confirm')}
            </Button>
            <Space width="2x" />
            <Button minWidth="20x" onClick={onClose}>
              {t('common.button.cancel')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
);

export default AdvancedTooltipModal;
